export function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

/**
 * Valide le mot de passe fourni selon les règles métier en place
 * @param pwd string
 * @param minLength int
 * @returns {{pwdHasNumber:boolean, pwdHasUpper:boolean, pwdLongEnough: bool, validPassword : bool }}
 */
export function validatePassword(pwd, minLength)
{
    let res = {};
    res.pwdHasNumber = /\d/.test(pwd);
    res.pwdHasUpper = /[A-Z]/.test(pwd);
    res.pwdLongEnough = pwd.length >= minLength;

    res.validPassword = res.pwdHasNumber && res.pwdHasUpper && res.pwdLongEnough;

    return res;
}

/**
 * Détecte le type de code d'organisation depuis le code fourni par SIRET/SIREN/UAI
 * NB : Vérification simple : se base uniquement sur le format du code fourni
 * @param raw
 * @returns {string|null}
 */
export function detectOrganizationCodeType(raw) {
    if (!raw) return null

    const clean = raw.replace(/\s/g, '')

    if (/^[0-9]{9}$/.test(clean)) return 'SIREN'
    if (/^[0-9]{14}$/.test(clean)) return 'SIRET'
    if (/^[0-9A-Z]{8}$/.test(clean)) return 'UAI'

    return null
}
